import { SoftwareAddonTemplate } from "../../../lib/model/addonTemplate";
import fs2crewLogo from "../../images/templates/fs2crew.png";

export const fs2crewTemplate: SoftwareAddonTemplate = {
  type: "software",
  id: "fs2crew",
  title: "FS2Crew",
  platforms: ["msfs", "p3d", "fsx"],
  image: fs2crewLogo,
  content: [
    {
      title: "Cockpit Preparation",
      roles: ["cockpitPreparation", "beforeFlightStart"],
      content: [
        {
          item: "FS2Crew",
          setting: "Started",
        },
        {
          item: "FS2Crew Preflight Events",
          setting: "Started",
        },
      ],
    },
    {
      title: "Before Flight Start",
      roles: ["beforeFlightStart", "beforePushback", "beforeEngineStart"],
      content: [
        {
          item: "Departure Briefing",
          setting: "Completed",
        },
      ],
    },
    {
      title: "Before Descent",
      roles: ["beforeDescent", "cruise"],
      content: [
        {
          item: "Approach Briefing",
          setting: "Completed",
        },
      ],
    },
  ],
};
